import type { i18n as i18nInstance } from "i18next";

import { enUS, frFR } from "./i18n";
import { useLayoutEffect } from "react";

interface Props {
  children: React.ReactNode;
  i18n: i18nInstance;
}

export const UseCasesProvider = ({ children, i18n }: Props) => {
  useLayoutEffect(() => {
    if (!i18n.hasResourceBundle("en-US", "use-cases")) {
      i18n.addResourceBundle("en-US", "use-cases", enUS);
    }
    if (!i18n.hasResourceBundle("fr-FR", "use-cases")) {
      i18n.addResourceBundle("fr-FR", "use-cases", frFR);
    }
  }, [i18n]);

  return children;
};
